<template>
  <div
    class="fixed top-0 right-0 z-30 overflow-visible w-panel max-w-full"
    :class="[{ 'pointer-events-none' : !isOpen }, getPosition]"
  >
    <transition name="fade">
      <div
        v-if="isOpen"
        class="absolute w-screen h-screen bg-black opacity-25 right-0 top-0 duration-500"
        :class="getPosition"
        @click="onClickOutsite"
      />
    </transition>
    <transition :name="`panel-${position}`">
      <div v-if="isOpen" class="flex flex-col h-screen relative bg-white shadow-2xl duration-300">
        <div class="px-8 mt-4 py-2 relative panel-scroll-gradient">
          <p class="font-medium">{{ title }}</p>
          <base-button
            square
            rounded
            class="is-gray-100 absolute top-half transform -translate-y-1/2"
            :class="getCloseButtonPosition"
            @click="close"
          >
            <span class="icon icon-close text-lg"></span>
          </base-button>
        </div>
        <div class="max-h-full h-full overflow-scroll">
          <slot />
        </div>
        <div class="relative border-t border-solid border-gray-200 panel-scroll-gradient-reversed" v-if="$slots.actions">
          <slot name="actions" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import eventHub from '../helpers/event-hub'

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: "default"
    },
    disableClickOutside: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'right'
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  created() {
    eventHub.$on(`panel:${this.name}:open`, () => {
      this.open();
    });
    eventHub.$on(`panel:${this.name}:close`, () => {
      this.close(true);
    });
  },
  beforeDestroy () {
    eventHub.$off([`panel:${this.name}:open`, `panel:${this.name}:close`])
  },
  computed: {
    getPosition () {
      return this.position.includes('right') ? 'right-0' : 'left-0'
    },
    getCloseButtonPosition () {
      return this.position.includes('right') ? 'left-0 -translate-x-1/2' : 'right-0 translate-x-1/2'
    }
  },
  methods: {
    open() {
      this.isOpen = true;
      document.body.style.overflow = 'hidden'
    },
    close(force = false) {
      if (this.$listeners.close && !force) {
        this.$emit("close");
      } else {
        this.isOpen = false;
      }
      document.body.style.overflow = 'auto'
    },
    onClickOutsite() {
      if (!this.disableClickOutside && !this.$listeners.close) {
        this.close();
      }
    }
  }
};
</script>

<style scoped>
.panel-scroll-gradient,
.panel-scroll-gradient-reversed {
  &::before {
    content: "";
    top: 100%;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    @apply absolute block w-full h-6 left-0 z-10 pointer-events-none;
  }
}

.panel-scroll-gradient-reversed::before {
  bottom: 100%;
  @apply top-auto transform rotate-180 mb-px;
}
.w-panel {
  width: 450px;
}
.fade-enter, .fade-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply opacity-0;
}
.panel-right-enter, .panel-right-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply transform translate-x-full scale-95 opacity-0;
}
.panel-left-enter, .panel-left-leave-to /* .scale-leave-active below version 2.1.8 */ {
  @apply transform -translate-x-full scale-95 opacity-0;
}
</style>
